<ngx-paypal *ngIf="finishLoad" [config]="payPalConfig"></ngx-paypal>
<ng-container *ngIf="!this.finishLoad">
  <mat-progress-spinner class="loader-spinner" [color]="'primary'" [value]="75" [mode]="'indeterminate'" [diameter]="120" [strokeWidth]="15">
  </mat-progress-spinner>
</ng-container>